import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import { jsx as _jsx } from "react/jsx-runtime";
export var Container = function Container(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (process.env.NODE_ENV === 'development') {
    if (className !== null && className !== void 0 && className.includes('tw-flex')) {
      console.error('You should not use the `tw-flex` class in the Container component. This component already contains a `grid` class that must not be overriden.');
    }
    if (className !== null && className !== void 0 && className.includes('tw-container')) {
      console.error('You should not use the `tw-container` class in the Container component. This component already contains a `container` class that must not be overriden.');
    }
    if (className !== null && className !== void 0 && className.includes('tw-gap')) {
      console.error('You should not use the `tw-gap` class in the Container component. This component already contains a `container` class that must not be overriden.');
    }
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: "tw-container ".concat(className || '')
  }, rest), {}, {
    children: children
  }));
};